<ng-container>
  <table appTable>
    <tbody appTbody>
      <ng-container *ngFor="let item of accordionlength; let index = index">
        <tr appTr [expandableRow]="expandableContent">
          <td class="title" appTd [appHighlight]="searchVal">
            <div class="d-flex align-items-center">
              <label>
                {{"Translation.Virtualoptions" | translate}}&nbsp;<span class="count"
                                                                        *ngIf="count">{{count}}</span>
              </label>
            </div>
          </td>
        </tr>

        <tr appTr #expandableContent>
          <td class="expanded-content" colspan="7" appTd>
            <div *ngFor="let item of virtualOptions;let index = index">
              <div style="width: 100%;">
                <div class="flex-container">
                  <app-checkbox-group title='{{item.category}}'>
                    <ul class="list" [style.columnCount]="2">
                      <li *ngFor="let options of item.additionalDetails;let i = index">
                        <app-checkbox [value]="options?.isChecked" label='{{options.label}}'
                                      (stateChanged)="changeItem($event,options.id)" [theme]="'blue'"> </app-checkbox>
                      </li>
                    </ul>
                  </app-checkbox-group>
                  <div *ngIf="item.categoryId == 2 && virtualOptionsBR" [formGroup]="form">
                    <label class="title brTitle">{{virtualOptionsBR.category}}</label>
                    <app-radio-group (stateChanged)="stateChanged($event)" formControlName="radio">
                      <ul [style.margin]="'6px 0px'" class="list">
                        <li *ngFor="let radio of virtualOptionsBR.additionalDetails">
                          <app-radio [value]="radio.id" [label]="radio.label" [theme]="'blue'"></app-radio>
                        </li>
                      </ul>
                    </app-radio-group>
                    <app-button *ngIf="form.controls.radio.value"
                                class="clearSection"
                                [kind]="'silent'"
                                (clicked)="clearSeaction()"
                                [label]="'Translation.ClearSelection' | translate"></app-button>
                  </div>
                </div>
              </div>
              <div *ngIf="index < virtualOptions.length-1" class="section-divider"><br></div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</ng-container>
